import 'bootstrap';

console.log('App loaded');